import React from 'react';

import BrandMark from './BrandMark';
import { formatLocaleDate } from '../../Utils/HelperFunctions';
import { DoneScreenStyles as S, ReviewScreenStyles as RS } from './styles';

const NEXT_STEPS = [
  'Your account team gets a copy of this scope and lines it up against every future takeoff you send us.',
  'Turnaround estimates come with each takeoff — driven by the scope you just picked.',
  'Anything change? Reply to your account team and they’ll reopen the form.'
];

const DoneScreen = ({ email, aeName, submittedAt, version }) => {
  const submittedLabel = submittedAt ? `Submitted ${formatLocaleDate(submittedAt)}.` : 'Submitted just now.';

  return (
    <S.PageWrap>
      <S.Content>
        <S.BrandRow>
          <BrandMark />
          <RS.Divider />
          <span>Scope form</span>
        </S.BrandRow>
        <S.Card>
          <S.CheckBadge>✓</S.CheckBadge>
          <S.TitleBlock>
            <S.Heading>Thanks — your scope is with us</S.Heading>
            <S.Paragraph>
              {submittedLabel} We&apos;ve sent a copy to {email || 'you'}.
            </S.Paragraph>
          </S.TitleBlock>
          <S.FiledUnderBox>
            <S.Uppercase>Filed under</S.Uppercase>
            <S.EmailBig>{email || 'your email'}</S.EmailBig>
            <S.SmallGrey>
              Quote this email address if you get in touch about your scope
              {version ? ` (version ${version})` : ''}.
            </S.SmallGrey>
          </S.FiledUnderBox>
          <S.NextStepsBlock>
            <S.NextStepsTitle>What happens next</S.NextStepsTitle>
            {NEXT_STEPS.map(text => (
              <S.BulletRow key={text}>
                <S.Bullet />
                <S.BulletText>{text}</S.BulletText>
              </S.BulletRow>
            ))}
          </S.NextStepsBlock>
          <S.PdfCallout>
            <S.PdfDot />
            <S.PdfText>
              A PDF copy of your scope is on its way to {email || 'you'} — keep it for your records or forward it to
              your team.
            </S.PdfText>
          </S.PdfCallout>
          {aeName && <S.AeHint>Need to change something? Reply to {aeName} and we&apos;ll reopen the form.</S.AeHint>}
        </S.Card>
      </S.Content>
    </S.PageWrap>
  );
};

export default DoneScreen;
